<!-- 新增数据库 -->
<template>
  <div class="bodys">
    <div class="topBtns">
      <i
        class="el-icon-close"
        style="font-size: 25px; cursor: pointer"
        @click="backOff"
      ></i>
      <div>
        <span class="topBtn" v-if="editInfo === ''">
          <el-button
            type="success"
            size="mini"
            :loading="editLoading"
            @click="preservation(1)"
            >保存草稿</el-button
          >
          <el-button
            type="primary"
            size="mini"
            :loading="editLoading"
            @click="preservation(2)"
            >保存</el-button
          >
        </span>
        <span class="topBtn" v-if="editInfo === '草稿箱'">
          <el-button
            type="success"
            size="mini"
            :loading="editLoading"
            @click="preservation(1)"
            >保存草稿</el-button
          >
          <el-button
            type="primary"
            size="mini"
            :loading="editLoading"
            @click="preservation(2)"
            >保存</el-button
          >
        </span>
      </div>
    </div>
    <div class="box_top">
      <p class="box_h3">中心信息</p>
    </div>
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      v-if="boxFalseOne"
    >
      <el-form-item label="中心名称">
        <el-select v-model="formInline.user" placeholder="请选择" clearable :disabled="disabled">
          <el-option
            v-for="(item, index) in formDate"
            :key="index"
            :label="item.CenterName"
            :value="item.CenterName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="科室" >
        <el-input
          placeholder="请输入"
          v-model="formInline.zoom"
          :disabled="disabled"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div>
      <div class="box_top">
        <div class="box_h3">科室信息</div>
        <!-- <p class="box_topA" @click="boxFalseOne = !boxFalseOne">
          {{ boxFalseOne ? "收起" : "展开" }}
        </p> -->
      </div>
      <table class="tableStyle" v-if="boxFalseOne">
          <thead>
            <tr>
              <th>PI姓名</th>
              <th>PI职务</th>
              <th>既往是否做过组长单位PI</th>
              <th>PI优势领域</th>
              <th>PI最高学历学校</th>
              <th>PI配合度</th>
              <th>PI兼职（学会任职等）</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <el-input
                  v-model="input.data1"
                  :disabled="disabledTable"
                ></el-input>
              </td>
              <td>
                <el-input
                  v-model="input.data2"
                  :disabled="disabledTable"
                ></el-input>
              </td>
              <td>
                <el-select
                  v-model="value10"
                  :disabled="disabledTable"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in allOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-input
                  v-model="input.data4"
                  :disabled="disabledTable"
                ></el-input>
              </td>
              <td>
                <el-input
                  v-model="input.data5"
                  :disabled="disabledTable"
                ></el-input>
              </td>
              <td>
                <el-select
                  v-model="value1"
                  :disabled="disabledTable"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <el-input
                  v-model="input.data6"
                  :disabled="disabledTable"
                ></el-input>
              </td>
            </tr>
          </tbody>
          <thead class="tableStyle">
            <tr>
              <th>执行PI（如PI直管则写PI）</th>
              <th>科室内PI影响力（人员调配、资源调配等）</th>
              <th>SUB-I及研究者配合度</th>
              <th>对应领域病源量（X例/月）</th>
              <th>科室在研项目及入组情况</th>
              <th>科室特殊要求</th>
              <th>PI喜好</th>
            </tr>
          </thead>
          <tr>
            <td>
              <el-input
                v-model="input.data7"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-select
                v-model="value2"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-select
                v-model="value3"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input
                v-model="input.data8"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data9"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data10"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data11"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
          </tr>
          <thead class="tableStyle">
            <tr>
              <th>我司是否承接过该科室项目</th>
              <th>我司在本科室承接项目数量</th>
              <th>我司在本科室承接项目适应症及入组情况</th>
              <th>科室是否接受外院推荐</th>
              <th>科室招募形式</th>
              <th>科室是否接受预筛</th>
              <th>我司是否为中心优选</th>
            </tr>
          </thead>
          <tr>
            <td>
              <el-select
                v-model="value4"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input
                v-model="input.data13"
                :disabled="disabledTable"
                type="number"
              ></el-input>
            </td>
            <td>
             <el-input
              v-model="input.data14"
              :disabled="disabledTable"
              type="textarea"
             ></el-input>
            </td>
            <td>
             <el-select
                v-model="value5"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> 
            </td>
            <td>
              <el-input
                v-model="input.data16"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-select
                v-model="value6"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-select
                v-model="value7"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
          </tr>
          <thead class="tableStyle">
            <tr>
              <th>机构选择SMO的要求</th>
              <th>机构对CRC的要求（经验等）</th>
              <th>立项要求（立项会、频率等）</th>
              <th>立项至启动耗时</th>
              <th>主协议模板（申办方/中心）</th>
              <th>若为中心模板，是否接受沟通变更为申办方模板</th>
              <th>中心主协议签署时长</th>
            </tr>
          </thead>
          <tr>
            <td>
              <el-input
              v-model="input.data19"
              :disabled="disabledTable"
              type="textarea"
            ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data20"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data21"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data22"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data23"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-select
                v-model="value17"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input
                v-model="input.data25"
                :disabled="disabledTable"
              ></el-input>
            </td>
          </tr>
          <thead class="tableStyle">
            <tr>
              <th>主协议最早审核时间点</th>
              <th>CRC协议模板（中心/SMO模板）</th>
              <th>CRC协议是否涉及费用</th>
              <th>CRC协议是否影响启动</th>
              <th>CRC协议最早审核时间点</th>
              <th>遗传办最早备案时间</th>
              <th>遗传办备案时长</th>
            </tr>
          </thead>
          <tr>
            <td>
              <el-date-picker
                v-model="input.data26"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :disabled="disabledTable"
              >
              </el-date-picker>
            </td>
            <td>
              <el-input
                v-model="input.data27"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-select
                v-model="value11"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-select
                v-model="value12"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-date-picker
                v-model="input.data30"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :disabled="disabledTable"
              >
              </el-date-picker>
            </td>
            <td>
              <el-date-picker
                v-model="input.data31"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :disabled="disabledTable"
              >
              </el-date-picker>
            </td>
            <td>
              <el-input
                v-model="input.data32"
                :disabled="disabledTable"
              ></el-input>
            </td>
          </tr>
          <thead class="tableStyle">
            <tr>
              <th>是否接受伦理前置</th>
              <th>是否需要组长单位批件</th>
              <th>伦理频率</th>
              <th>伦理会时间</th>
              <th>伦理批件（意见）取得时间</th>
              <th>初审伦理会形式（快审、会审）</th>
              <th>启动前中心特殊要求（物资、药品、免费检查等）</th>
            </tr>
          </thead>
          <tr>
            <td>
              <el-select
                v-model="value16"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-select
                v-model="value13"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input
                v-model="input.data35"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-date-picker
                v-model="input.data36"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :disabled="disabledTable"
              >
              </el-date-picker>
            </td>
            <td>
              <el-date-picker
                v-model="input.data37"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :disabled="disabledTable"
              >
              </el-date-picker>
            </td>
            <td>
              <el-input
                v-model="input.data38"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data39"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
          </tr>
          <thead class="tableStyle">
            <tr>
              <th>机构对PI承接项目的要求</th>
              <th>疫情防控期间启动特殊要求</th>
              <th>受试者报销时长（Xh/月）</th>
              <th>中心特殊耗时流程</th>
              <th>是否使用CTMS系统</th>
              <th>中心要求使用纸质病历/电子病历</th>
              <th>是否涉及跨院区工作</th>
            </tr>
          </thead>
          <tr>
            <td>
              <el-input
                v-model="input.data40"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data41"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data42"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="input.data43"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
            <td>
              <el-select
                v-model="value14"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input
                v-model="input.data45"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td>
              <el-select
                v-model="value15"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
          </tr>
          <thead class="tableStyle">
            <tr>
              <th colspan="2">是否存在偏远院区开展实验</th>
              <th colspan="2">I期项目是否在I期病房开展</th>
              <th>我司中心人员覆盖数</th>
              <th colspan="2">其他未尽事项</th>
            </tr>
          </thead>
          <tr>
            <td colspan="2">
              <el-select
                v-model="value8"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td colspan="2">
              <el-select
                v-model="value9"
                :disabled="disabledTable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input
                v-model="input.data49"
                :disabled="disabledTable"
              ></el-input>
            </td>
            <td colspan="2">
              <el-input
                v-model="input.data50"
                :disabled="disabledTable"
                type="textarea"
              ></el-input>
            </td>
          </tr>
        </table>
    </div>
  </div>
</template>

<script>
import {
  GetCRCCenterList,
  SetQualityRptList,
} from "../../api/api";
import uuidv4 from "uuid/v4";
import addWatermark from '@/utils/watermark.js' // 引入水印方法
import moment from "moment";
export default {
  data() {
    return {
      editLoading: false,
      formInline: {
        user: "",
        zoom: "",
      },
      input: {
        data1: "",
        data2: "",
        data4: "",
        data5: "",
        data6: "",
        data7: "",
        data8: "",
        data9: "",
        data10: "",
        data11: "",
        data13: "",
        data14: "",
        data16: "",
        data18: "",
        data19: "",
        data20: "",
        data21: "",
        data22: "",
        data23: "",
        data25: "",
        data26: "",
        data27: "",
        data30: "",
        data31: "",
        data32: "",
        data35: "",
        data36: "",
        data37: "",
        data38: "",
        data39: "",
        data40: "",
        data41: "",
        data42: "",
        data43: "",
        data45: "",
        data49: "",
        data50: "",
      }, // 表格数据
      boxFalseOne: true,
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "", 
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10:"",
      value11:"",
      value12:"",
      value13:"",
      value14:"",
      value15:"",
      value16:"",
      value17:"",
      options: [
        {
          value: "高",
          label: "高",
        },
        {
          value: "中",
          label: "中",
        },
        {
          value: "低",
          label: "低",
        },
      ],
      allOptions:[
        {
          value: "是",
          label: "是",
        },
        {
          value:"否",
          label:"否",
        }
    ],
      formDate: [],
      detailedData: {
        WorkFlowList: [],
        CallReportId: 0,
        UUID: uuidv4(),
        UserId: 0,
        TemplateId: 101,
        CallDate: "",
        ProjectId: 0,
        CenterId: 0,
        Memo1: "",
        Memo2: "",
        Memo3: "",
        Memo4: "",
        Memo5: "",
        Memo6: "",
        Memo7: "",
        Memo8: "",
        Memo9: "",
        Memo10: "",
        Memo11: "",
        Memo12: "",
        Memo13: "",
        Memo14: "",
        Memo15: "",
        Memo16: "",
        Memo17: "",
        Memo18: "",
        Memo19: "",
        Memo20: "",
        Memo21: "",
        Memo22: "",
        Memo23: "",
        Memo24: "",
        Memo25: "",
        Memo26: "",
        Memo27: "",
        Memo28: "",
        Memo29: "",
        Memo30: "",
        Memo31: "",
        Memo32: "",
        Memo33: "",
        Memo34: "",
        Memo35: "",
        Memo36: "",
        Memo37: "",
        Memo38: "",
        Memo39: "",
        Memo40: "",
        Memo41: "",
        Memo42: "",
        Memo43: "",
        Memo44: "",
        Memo45: "",
        Memo46: "",
        Memo47: "",
        Memo48: "",
        Memo49: "",
        Memo50: "",
        UserName: "",
        AllowEdit: 1,
        AllowPlaceFile: 0,
        AllowDel: 0,
        AllowAuth: 0,
        AllowEditDtlColumn: "",
      },
      stateName: "",
      tikulist: {
        Types: 0,
        CallReportId: 0,
        ProjectId: 0,
        ProjectName: "",
        CenterName: "",
        ProjectType: 101,
        Indications: "",
        Stages: "",
        Progress: "",
        Steps: "",
        PMName: "",
        SWName: "",
        sw: "",
        DepName: "",
        sw1: "",
        sw2: "",
        sw3: "",
        sw4: "",
        sw5: "",
        PageIndex: 0,
        PageSize: 20,
        Skip: 0,
        RequetUrl: "",
      },
      tableData: [],
      disabled:false,
      editInfo:"",
      disabledTable:false,
    };
  },
  mounted() {
    // 添加水印
    const userInfo = JSON.parse(localStorage.getItem("cur-user-info"));
    if(userInfo.showWatermark) {
      const time = moment().format("YYYY-MM-DD");
      addWatermark({
        content: userInfo.UserName + time,
      });
    }
    
    this.getInfo();
    window.sessionStorage.setItem("stateName", "新增");
    
    const lookData = JSON.parse(window.localStorage.getItem("lookData"));
      if (lookData) {
        this.formInline = {
          user: lookData.Memo49[0],
          zoom: lookData.Memo49[1],
        };
        this.value1 = lookData.Memo4.split(",")[1],
        this.value2 = lookData.Memo6.split(",")[0],
        this.value3 = lookData.Memo6.split(",")[1],
        this.value4 = lookData.Memo10.split(",")[0],
        this.value5 = lookData.Memo13,
        this.value6 = lookData.Memo15,
        this.value7 = lookData.Memo16,
        this.value8 =  lookData.Memo45,
        this.value9 = lookData.Memo46,
        this.value10 = lookData.Memo2,
        this.value11 = lookData.Memo26,
        this.value12 = lookData.Memo27,
        this.value13 = lookData.Memo32,
        this.value14 = lookData.Memo42,
        this.value15 = lookData.Memo44,
        this.value16 = lookData.Memo31,
        this.value17 = lookData.Memo22,
        this.input = {
          data1: lookData.Memo1[0],
          data2: lookData.Memo1[1],
          data4: lookData.Memo3,
          data5: lookData.Memo4.split(",")[0],
          data6: lookData.Memo4.split(",")[2],
          data7: lookData.Memo5,
          data8: lookData.Memo6.split(",")[2],
          data9: lookData.Memo7,
          data10: lookData.Memo8,
          data11: lookData.Memo9,
          data13: lookData.Memo10.split(",")[1],
          data14:lookData.Memo11,
          data16: lookData.Memo14,
          data19: lookData.Memo17,
          data20: lookData.Memo18,
          data21: lookData.Memo19,
          data22: lookData.Memo20,
          data23: lookData.Memo21,
          data25: lookData.Memo23,
          data26: lookData.Memo24,
          data27: lookData.Memo25,
          data30: lookData.Memo28,
          data31: lookData.Memo29,
          data32: lookData.Memo30,
          data35: lookData.Memo33,
          data36: lookData.Memo34,
          data37: lookData.Memo35,
          data38: lookData.Memo36,
          data39: lookData.Memo37,
          data40: lookData.Memo38,
          data41: lookData.Memo39,
          data42: lookData.Memo40,
          data43: lookData.Memo41,
          data45: lookData.Memo43,
          data49: lookData.Memo47,
          data50: lookData.Memo48,
        };
        this.detailedData.CallReportId = lookData.CallReportId;
        this.disabled = true;
        this.editInfo = lookData.Memo50;
      }
      this.getDisabledTable();
  },
  methods: {
    //回退路由
    backOff(e) {
      window.opener = null;
      window.close();
    },
    // 获取项目信息
    getInfo() {
      GetCRCCenterList({
        CenterId: 0,
        ProjectId: 0,
        SearchType: 0,
        CenterName: "",
        RegionName: "",
        sw: "",
        PageIndex: 0,
        PageSize: 10000,
        Skip: 0,
        RequetUrl: "",
      }).then((res) => {
        if (res.data.Code != 1) this.$message.error(res.data.Msg);
        this.formDate = res.data.Data;
      });
    },
    // 新增的项目信息
    preservation(num) {
      if (!this.formInline.user) {
        return this.$message.error("中心名称不能为空");
      }
      if (!this.formInline.zoom) {
        return this.$message.error("科室不能为空");
      }
      if (!this.input.data1) {
        return this.$message.error("PI姓名不能为空");
      }
      if (!this.input.data2) {
        return this.$message.error("PI职务不能为空");
      }
      if (num == 1) {
        if (this.input.data1 || this.input.data2) {
          this.detailedData.Memo1 = this.input.data1 + "," + this.input.data2;
        }
        if (this.value10) {
          this.detailedData.Memo2 = this.value10;
        }
        if (this.input.data4) {
          this.detailedData.Memo3 = this.input.data4;
        }
        if (this.input.data5 || this.value1 || this.input.data6) {
          this.detailedData.Memo4 =
            this.input.data5 + "," + this.value1 + "," + this.input.data6;
        }
        if (this.input.data7) {
          this.detailedData.Memo5 = this.input.data7;
        }
        if (this.value2 || this.value3 || this.input.data8) {
          this.detailedData.Memo6 =
            this.value2 + "," + this.value3 + "," + this.input.data8;
        }
        if (this.input.data9) {
          this.detailedData.Memo7 = this.input.data9;
        }
        if (this.input.data10) {
          this.detailedData.Memo8 = this.input.data10;
        }
        if (this.input.data11) {
          this.detailedData.Memo9 = this.input.data11;
        }
        if (this.value4 || this.input.data13) {
          this.detailedData.Memo10 =
          this.value4 + "," + this.input.data13;
        }
        if (this.input.data14) {
          this.detailedData.Memo11 = this.input.data14;
        }
        if (this.value5) {
          this.detailedData.Memo13 = this.value5;
        }
        if (this.input.data16) {
          this.detailedData.Memo14 = this.input.data16;
        }
        if (this.value6) {
          this.detailedData.Memo15 = this.value6;
        }
        if (this.value7) {
          this.detailedData.Memo16 = this.value7;
        }
        if (this.input.data19) {
          this.detailedData.Memo17 = this.input.data19;
        }
        if (this.input.data20) {
          this.detailedData.Memo18 = this.input.data20;
        }
        if (this.input.data21) {
          this.detailedData.Memo19 = this.input.data21;
        }
        if (this.input.data22) {
          this.detailedData.Memo20 = this.input.data22;
        }
        if (this.input.data23) {
          this.detailedData.Memo21 = this.input.data23;
        }
        if (this.value17) {
          this.detailedData.Memo22 = this.value17;
        }
        if (this.input.data25) {
          this.detailedData.Memo23 = this.input.data25;
        }
        if (this.input.data26) {
          this.detailedData.Memo24 = this.input.data26;
        }
        if (this.input.data27) {
          this.detailedData.Memo25 = this.input.data27;
        }
        if (this.value11) {
          this.detailedData.Memo26 = this.value11;
        }
        if (this.value12) {
          this.detailedData.Memo27 = this.value12;
        }
        if (this.input.data30) {
          this.detailedData.Memo28 = this.input.data30;
        }
        if (this.input.data31) {
          this.detailedData.Memo29 = this.input.data31;
        }
        if (this.input.data32) {
          this.detailedData.Memo30 = this.input.data32;
        }
        if (this.value16) {
          this.detailedData.Memo31 = this.value16;
        }
        if (this.value13) {
          this.detailedData.Memo32 = this.value13;
        }
        if (this.input.data35) {
          this.detailedData.Memo33 = this.input.data35;
        }
        if (this.input.data36) {
          this.detailedData.Memo34 = this.input.data36;
        }
        if (this.input.data37) {
          this.detailedData.Memo35 = this.input.data37;
        }
        if (this.input.data38) {
          this.detailedData.Memo36 = this.input.data38;
        }
        if (this.input.data39) {
          this.detailedData.Memo37 = this.input.data39;
        }
        if (this.input.data40) {
          this.detailedData.Memo38 = this.input.data40;
        }
        if (this.input.data41) {
          this.detailedData.Memo39 = this.input.data41;
        }
        if (this.input.data42) {
          this.detailedData.Memo40 = this.input.data42;
        }
        if (this.input.data43) {
          this.detailedData.Memo41 = this.input.data43;
        }
        if (this.value14) {
          this.detailedData.Memo42 = this.value14;
        }
        if (this.input.data45) {
          this.detailedData.Memo43 = this.input.data45;
        }
        if (this.value15) {
          this.detailedData.Memo44 = this.value15;
        }
        if (this.value8) {
          this.detailedData.Memo45 = this.value8;
        }
        if (this.value9) {
          this.detailedData.Memo46 = this.value9;
        }
        if (this.input.data49) {
          this.detailedData.Memo47 = this.input.data49;
        }
        if (this.input.data50) {
          this.detailedData.Memo48 = this.input.data50;
        }
        if (this.formInline.user || this.formInline.zoom) {
          this.detailedData.Memo49 =
          this.formInline.user + "," + this.formInline.zoom;
        }
        this.editLoading = true;
        this.detailedData.Memo50 = "草稿箱";
        window.sessionStorage.setItem("stateName", "草稿箱");
        SetQualityRptList(this.detailedData).then((res) => {
          if (res.data.Code == -1) {
            this.editLoading = false;
            return this.$message.error(res.data.Msg);
          }
          this.$message.success("保存草稿成功!");
          this.$router.push('/dbManage');
        });
      }
      if (num == 2) {
        if (this.input.data1 || this.input.data2) {
          this.detailedData.Memo1 = this.input.data1 + "," + this.input.data2;
        }
        if (this.value10) {
          this.detailedData.Memo2 = this.value10;
        }
        if (this.input.data4) {
          this.detailedData.Memo3 = this.input.data4;
        }
        if (this.input.data5 || this.value1 || this.input.data6) {
          this.detailedData.Memo4 =
            this.input.data5 + "," + this.value1 + "," + this.input.data6;
        }
        if (this.input.data7) {
          this.detailedData.Memo5 = this.input.data7;
        }
        if (this.value2 || this.value3 || this.input.data8) {
          this.detailedData.Memo6 =
            this.value2 + "," + this.value3 + "," + this.input.data8;
        }
        if (this.input.data9) {
          this.detailedData.Memo7 = this.input.data9;
        }
        if (this.input.data10) {
          this.detailedData.Memo8 = this.input.data10;
        }
        if (this.input.data11) {
          this.detailedData.Memo9 = this.input.data11;
        }
        if (this.value4 || this.input.data13) {
        this.detailedData.Memo10 =
            this.value4 + "," + this.input.data13;
        }
        if (this.input.data14) {
          this.detailedData.Memo11 = this.input.data14;
        }
        if (this.value5) {
          this.detailedData.Memo13 = this.value5;
        }
        if (this.input.data16) {
          this.detailedData.Memo14 = this.input.data16;
        }
        if (this.value6) {
          this.detailedData.Memo15 = this.value6;
        }
        if (this.value7) {
          this.detailedData.Memo16 = this.value7;
        }
        if (this.input.data19) {
          this.detailedData.Memo17 = this.input.data19;
        }
        if (this.input.data20) {
          this.detailedData.Memo18 = this.input.data20;
        }
        if (this.input.data21) {
          this.detailedData.Memo19 = this.input.data21;
        }
        if (this.input.data22) {
          this.detailedData.Memo20 = this.input.data22;
        }
        if (this.input.data23) {
          this.detailedData.Memo21 = this.input.data23;
        }
        if (this.value17) {
          this.detailedData.Memo22 = this.value17;
        }
        if (this.input.data25) {
          this.detailedData.Memo23 = this.input.data25;
        }
        if (this.input.data26) {
          this.detailedData.Memo24 = this.input.data26;
        }
        if (this.input.data27) {
          this.detailedData.Memo25 = this.input.data27;
        }
        if (this.value11) {
          this.detailedData.Memo26 = this.value11;
        }
        if (this.value12) {
          this.detailedData.Memo27 = this.value12;
        }
        if (this.input.data30) {
          this.detailedData.Memo28 = this.input.data30;
        }
        if (this.input.data31) {
          this.detailedData.Memo29 = this.input.data31;
        }
        if (this.input.data32) {
          this.detailedData.Memo30 = this.input.data32;
        }
        if (this.value16) {
          this.detailedData.Memo31 = this.value16;
        }
        if (this.value13) {
          this.detailedData.Memo32 = this.value13;
        }
        if (this.input.data35) {
          this.detailedData.Memo33 = this.input.data35;
        }
        if (this.input.data36) {
          this.detailedData.Memo34 = this.input.data36;
        }
        if (this.input.data37) {
          this.detailedData.Memo35 = this.input.data37;
        }
        if (this.input.data38) {
          this.detailedData.Memo36 = this.input.data38;
        }
        if (this.input.data39) {
          this.detailedData.Memo37 = this.input.data39;
        }
        if (this.input.data40) {
          this.detailedData.Memo38 = this.input.data40;
        }
        if (this.input.data41) {
          this.detailedData.Memo39 = this.input.data41;
        }
        if (this.input.data42) {
          this.detailedData.Memo40 = this.input.data42;
        }
        if (this.input.data43) {
          this.detailedData.Memo41 = this.input.data43;
        }
        if (this.value14) {
          this.detailedData.Memo42 = this.value14;
        }
        if (this.input.data45) {
          this.detailedData.Memo43 = this.input.data45;
        }
        if (this.value15) {
          this.detailedData.Memo44 = this.value15;
        }
        if (this.value8) {
          this.detailedData.Memo45 = this.value8;
        }
        if (this.value9) {
          this.detailedData.Memo46 = this.value9;
        }
        if (this.input.data49) {
          this.detailedData.Memo47 = this.input.data49;
        }
        if (this.input.data50) {
          this.detailedData.Memo48 = this.input.data50;
        }
        if (this.formInline.user || this.formInline.zoom) {
          this.detailedData.Memo49 =
            this.formInline.user + "," + this.formInline.zoom;
        }
        this.editLoading = true;
        this.detailedData.Memo50 = "已发布";
        window.sessionStorage.setItem("stateName", "已发布");
        SetQualityRptList(this.detailedData).then((res) => {
          if (res.data.Code == -1) {
            this.editLoading = false;
            return this.$message.error(res.data.Msg);
          }
          this.$message.success("保存成功!");
          this.$router.push('/dbManage');
        });
      }
    },
    // 已发布的数不可编辑
    getDisabledTable(){
      if(this.editInfo === "已发布"){
        this.disabledTable = true;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.bodys {
  padding: 0 20px;
  padding-bottom: 20px;
  font-size: 12px;
  min-width: 1400px;
}
.topBtns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.topBtn {
  margin-right: 100px;
}
.box_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.box_topA {
  cursor: pointer;
  color: #4696fc;
  border: 1px solid #4696fc;
  user-select: none;
  padding: 2px 10px;
  border-radius: 5px;
}

.box_h3 {
  color: #4696fc;
  font-weight: bold;
}

.demo-form-inline {
  display: flex;
  /deep/ .el-input {
    width: 400px;
  }
  /deep/ .el-input__inner {
    line-height: 30px;
    height: 30px;
  }
}

.tableStyle {
  min-width: 1300px;
  width: 100%;
  border-collapse: collapse;
  /deep/ .el-cascader {
    height: 25px;
    line-height: 25px;
  }

  /deep/ .el-input__inner {
    height: 25px;
    line-height: 25px;
    border: 0px solid #dcdfe6;
    padding: 0 5px;
  }

  /deep/ .el-input__prefix {
    display: none;
  }
  /deep/ .el-input__icon {
    height: 25px;
    line-height: 25px;
  }
}

td,
th {
  line-height: 20px;
  height: 20px;
  border: 1px solid #ccc;
  text-align: center;
  padding: 5px;
}

th {
  background-color: rgba(221, 221, 221, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/info/addDataBase.vue